import React from "react";
import { Button, Col, Descriptions, Modal, Row, Typography } from "antd";
import { MagnaBank } from "../common/Constants";

const BankInfoModal = ({ isModalOpen, setIsModalOpen }) => {

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal
        width={800}
        open={isModalOpen}
        onCancel={handleCancel}
        title={"Magna Foodservice Bank Information"}
        style={{
          top: "10%",
        }}
        footer={[
          <Button
            size="large"
            onClick={handleCancel}
          >
            {'Close'}
          </Button>, ,
        ]}
      >
        <>
          <Descriptions bordered size={"large"} labelStyle={{ width: "300px", fontSize: "20px" }} contentStyle={{ fontSize: "20px" }}>
            <Descriptions.Item
              label={`VAT Number`}
              labelStyle={{ width: "300px" }}
            >
              {MagnaBank.vat}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions bordered size={"large"} labelStyle={{ width: "300px", fontSize: "20px" }} contentStyle={{ fontSize: "20px" }}>
            <Descriptions.Item
              label={`Bank Name`}
              labelStyle={{ width: "300px" }}
            >
              {MagnaBank.name}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions bordered size={"large"} labelStyle={{ width: "300px", fontSize: "20px" }} contentStyle={{ fontSize: "20px" }}>
            <Descriptions.Item
              label={`Account Name`}
              labelStyle={{ width: "300px" }}
            >
              {MagnaBank.title}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions bordered size={"large"} labelStyle={{ width: "300px", fontSize: "20px" }} contentStyle={{ fontSize: "20px" }}>
            <Descriptions.Item
              label={`Sort Code`}
              labelStyle={{ width: "300px" }}
            >
              {MagnaBank.sortCode}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions bordered size={"large"} labelStyle={{ width: "300px", fontSize: "20px" }} contentStyle={{ fontSize: "20px" }}>
            <Descriptions.Item
              label={`Account Number`}
              labelStyle={{ width: "300px" }}
            >
              {MagnaBank.accNumber}
            </Descriptions.Item>
          </Descriptions>
          <Row align="start" style={{ padding: "16px 0", display: 'flex', flexDirection: 'column' }}>
            <Col style={{ marginBottom: '10px' }}>
              <Typography.Text strong>Email:</Typography.Text>{" "}
              <a href={`mailto:${MagnaBank.email}`}>{MagnaBank.email}</a>
            </Col>
            <Col>
              <Typography.Text strong>Phone:</Typography.Text>{" "}
              <a href={`tel:${MagnaBank.telephone}`}>{MagnaBank.phone}</a>
            </Col>
          </Row>

        </>

      </Modal>
    </>
  );
};

export default BankInfoModal;
